import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's126g-s126m01',
    templateUrl: './s126g-s126m01.component.html'
})
export class S126gS126m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    revnbr: any = {};
    coup1a: any = {};
    coup1b: any = {};
    coup1c: any = {};
    coup2a: any = {};
    coup2b: any = {};
    coup2c: any = {};
    coup3a: any = {};
    coup3b: any = {};
    coup3c: any = {};
    coup4a: any = {};
    coup4b: any = {};
    coup4c: any = {};
    msgln: any = {};
    selmen: any = {'value': '2-SEL'};
    prev: any = {'value': '7-PREV'};
    next: any = {'value': '8-NEXT'};
    usage: any = {'value': '10-USAGE'};
    pagt: any = {'value': '11-PAGT'};
    currc1: any = {'value': 'SH4-CUST INQ'};
    prevc1: any = {'value': 'SH3-PREV CUST INQ'};
    paymt: any = {'value': 'SH5-PAYMT'};
    last: any = {'value': 'SH6-LAST'};
    first: any = {'value': 'SH7-FIRST'};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'revnbr', 'coup1a', 'coup1b', 'coup1c', 'coup2a', 'coup2b', 'coup2c', 'coup3a', 'coup3b', 'coup3c', 'coup4a', 'coup4b', 'coup4c', 'msgln', 'selmen', 'prev', 'next', 'usage', 'pagt', 'currc1', 'prevc1', 'paymt', 'last', 'first'];
    public LINES: number[] = [1, 2, 4, 5, 6, 7, 8, 9, 11, 12, 13, 15, 16, 17, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
